<app-header [text]="'header.registration'"></app-header>
<app-header-caption [text]="'header.registration_caption'"></app-header-caption>
<app-registration-form></app-registration-form>
